//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
let d=[[[0,"CloseBehavior",1,0]],[[["numberOfSpools"],"GetSpools",{R_:{spools:"MechanicalRouting.Spool[]"}},0,0],[["spools"],"SetSpools",{},1,0],[[],"OutputReport",{},0,0],[["numberOfUpToDateSpools","upToDateSpools"],"GetUpToDateSpools",{},0,0],[["numberOfUpdatedSpools","updatedSpools"],"GetUpdatedSpools",{},0,0],[["numberOfFailedSpools","failedSpools"],"GetFailedSpools",{},0,0]],[]];
SPLM.MechanicalRouting.PublishSpoolAssembliesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.PublishSpoolAssembliesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.PublishSpoolAssembliesBuilder.CloseAfterSaveBehavior = Object.freeze({
    "DontClose" : "DontClose", "Close" : "Close"});

export default SPLM;